<template>
  <div>
    <el-card body-style="padding: 0">
      <el-form ref="roleQueryForm" :model="roleQueryForm" label-width="80px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="角色" prop="roleLike">
              <el-input v-model="roleQueryForm.roleLike"
                        placeholder="请输入角色名称或角色编码或角色描述"/>
            </el-form-item>
          </el-col>
          <el-col :span="6" :offset="6">
            <el-form-item>
              <el-button type="primary" size="small"
                         @click="submitQueryForm()" icon="el-icon-search">
                查询</el-button>
              <el-button type="primary" size="small" plain
                         @click="resetQueryForm('roleQueryForm')" icon="el-icon-refresh">
                重置</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <el-card>
      <el-button type="primary" size="small" style="margin: 0 0 10px 20px"
                 icon="el-icon-plus" @click="handleAdd()">新增</el-button>

      <el-table :data="tableData" border default-expand-all stripe style="width: 100%;margin-bottom: 20px;">
        <el-table-column prop="roleName" label="角色名称" width="200" align="center"/>
        <el-table-column prop="roleCode" label="角色编码" width="200" align="center"/>
        <el-table-column prop="roleSort" label="排序" width="200" align="center"/>
        <el-table-column prop="roleStatus" label="是否禁用" width="" align="center">
          <template slot-scope="scope">
            <el-switch
              active-text ="是"
              inactive-text = "否"
              v-model="scope.row.roleStatus"
              @change=changeStatus(scope.$index,scope.row) >
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="roleDesc" label="角色描述" width="" align="center"/>
        <el-table-column label="操作" width="320" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" icon="el-icon-edit" circle
                       @click="handleEdit(scope.$index, scope.row)"/>
            <el-button size="mini" type="danger" icon="el-icon-delete" circle
                       @click="handleDelete(scope.$index, scope.row)"/>
            <el-button size="mini" type="success"
                       @click="assignPerm(scope.$index, scope.row)">
              分配权限
            </el-button>
            <el-button size="mini" type="success"
                       :disabled="scope.row.roleCode!='cuservices'
                       &&scope.row.roleCode!='manager'
                       &&scope.row.roleCode!='returnfinance'
                       &&scope.row.roleCode!='ownermanager'"
                       @click="otherAssignPerm(scope.$index, scope.row)">
              其它权限配置
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 新增对话框，设置字段操作的权限 -->

    <el-dialog :title="dialogFieldTitle" :visible.sync="dialogFieldFormVisible">
      <el-form :model="dialogFieldForm" ref="dialogFieldForm" label-width="180px">
        <el-checkbox-group v-model="b2cAccessFieldInfos">
        <div v-for="(value, key) in allFields" :key="key">
            <el-form-item :label="key" prop="menuName">
              <div v-for="item in value" :key="item.id">
                <el-checkbox :label="item.id">{{item.accessField}}</el-checkbox>
              </div>
            </el-form-item>
        </div>
        </el-checkbox-group>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="submitFieldDialogForm" size="mini" type="primary">提 交</el-button>
        <el-button @click="handleFieldCloseDialog" size="mini">取 消</el-button>
      </div>
    </el-dialog>

    <!-- end -->

    <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible"
               :before-close="beforeDialogClose">
      <el-form :model="dialogForm" ref="dialogForm"
               :rules="dialogFormRules" label-width="80px">

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="角色名称" prop="roleName">
              <el-input v-model="dialogForm.roleName" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="角色编码" prop="roleCode">
              <el-input v-model="dialogForm.roleCode" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="角色描述" prop="roleDesc">
              <el-input v-model="dialogForm.roleDesc"  label="角色描述"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="排序序号" prop="roleSort">
              <el-input-number v-model="dialogForm.roleSort" :min="1"  label="排序序号"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="submitDialogForm" size="mini" type="primary">确 定</el-button>
        <el-button @click="handleCloseDialog" size="mini">取 消</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="permDialogTitle" :visible.sync="permDialogVisible">
      <el-row>
        <el-col :span="12">
          <multi-tree
            :data="menuData"
            :labelPropName="menuLabelPropName"
            :buttonName="menuButtonName"
            :defaultExpandedKeys="menuDefaultExpandedKeys"
            :defaultCheckedKeys="menuDefaultCheckedKeys"
            @handleCheckedKeys="handleMenuCheckedKeys"></multi-tree>
        </el-col>
        <el-col :span="12">
          <multi-tree
            :data="apiData"
            :labelPropName="apiLabelPropName"
            :buttonName="apiButtonName"
            :defaultExpandedKeys="apiDefaultExpandedKeys"
            :defaultCheckedKeys="apiDefaultCheckedKeys"
            @handleCheckedKeys="handleApiCheckedKeys"></multi-tree>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import {
  getRoles,
  updateRole,
  addRole,
  deleteRole,
  changeRoleStatus,
  queryAccessFieldInfos,
  queryRoleAccessField, addAccessFieldToRole
} from '@/api/system/sys_role'
  import {getMenuCheckedTree,saveMenuCheckedKeys} from '@/api/system/sys_menu'
  import {getApiCheckedTree,saveApiCheckedKeys} from '@/api/system/sys_api'
  import axios from 'axios'
  import MultiTree from "../../components/MultiTree";
import {isObjectEmpty} from "@/lib/utils";

  export default {
    name: "SystemRole",
    components: {MultiTree},
    data() {
      return {
        tableData: [],
        roleQueryForm:{
          roleLike: ""
        },
        dialogFormVisible: false,
        dialogTitle:"",
        dialogForm: {
          id: null,
          roleName: '',
          roleCode: '',
          roleDesc: '',
          roleSort: ''
        },
        /*添加字段权限*/
        dialogFieldFormVisible: false,
        dialogFieldTitle:"",
        dialogFieldForm: {
          roleCode: '',
          b2cAccessFieldInfos: []
        },
        b2cAccessFieldInfos: [],
        allFields: [],
        /*end*/
        dialogFormRules: {
          roleName: [
            {required: true, message: '请输入角色名称', trigger: 'blur'},
          ],
          roleCode: [
            {required: true, message: '请输入角色编码', trigger: 'blur'},
            {pattern: /^[A-Za-z0-9]+$/, message: '只能包含英文、数字', trigger: 'blur'}
          ],
          roleDesc: [
            {required: true, message: '请输入角色描述信息', trigger: 'blur'},
          ]
        },
        handlingRoleId: null,  //当前正为哪一个角色分配权限：roleId
        handlingRoleCode: null, //当前正为哪一个角色分配权限：roleCode
        permDialogVisible:false,
        permDialogTitle:"",
        menuData:[],
        menuLabelPropName:"menuName",
        menuButtonName:"保存菜单查看权限",
        menuDefaultExpandedKeys:[],
        menuDefaultCheckedKeys:[],
        apiData:[],
        apiLabelPropName:"apiName",
        apiButtonName:"保存接口访问权限",
        apiDefaultExpandedKeys:[],
        apiDefaultCheckedKeys:[]
      }
    },
    methods: {
      submitFieldDialogForm(){
        for (let itemKey in this.allFields){
          this.dialogFieldForm.b2cAccessFieldInfos = [...this.dialogFieldForm.b2cAccessFieldInfos, ...this.allFields[itemKey].filter(it => {
              if (this.b2cAccessFieldInfos.includes(it.id)&& !isObjectEmpty(it)){
                return it;
              }
            })];
        }
        //console.log(this.dialogFieldForm.b2cAccessFieldInfos, this.b2cAccessFieldInfos)
        addAccessFieldToRole(this.dialogFieldForm).then(res => {
          if (res.success){
            this.handleFieldCloseDialog();
          }
        }).catch(err => {
          this.$message({message: err.message, type: 'error'});
          this.handleFieldCloseDialog();
        })
      },
      handleFieldCloseDialog(){
        this.$refs['dialogFieldForm'].resetFields();
        this.dialogFieldFormVisible = false;
      },
      submitQueryForm() {
        getRoles(this.roleQueryForm.roleLike)
          .then(res => {
            this.setData(res)
          })
      },
      resetQueryForm(formName) {
        this.$refs[formName].resetFields();
        this.submitQueryForm(formName)
      },
      changeStatus(index,row){
        changeRoleStatus(row.id,row.status).then(res => {
          if(res.isok){ //如果请求成功，给出成功信息提示
            //res.data=controller返回的数据
            this.$message({message: res.data, type: 'success'});
          }
        })
      },
      handleAdd(){
        this.dialogFormVisible = true;
        this.dialogTitle = "新增角色"
        this.resetDialogForm()
      },
      handleEdit(index, row) {
        this.dialogFormVisible = true;
        this.dialogTitle = "修改角色"
        this.resetDialogForm()
        this.dialogForm = {...row}
      },
      resetDialogForm(){
        this.dialogForm.id = null
        this.dialogForm.roleName = ''
        this.dialogForm.roleCode = ''
        this.dialogForm.roleDesc = ''
        this.dialogForm.roleSort = ''
      },
      submitDialogForm(){
        this.$refs.dialogForm.validate((valid) => {
          if (valid) {
            this.$confirm("确定提交数据么?")
              .then(_ => {
                if(this.dialogForm.id){ //有id是更新数据，没有id是新增数据
                  updateRole(this.dialogForm)
                    .then(res => {
                      this.$message({message: res.data, type: 'success'});
                      this.submitQueryForm();//修改之后，重新查询table
                      this.handleCloseDialog();
                    })
                }else {
                  addRole(this.dialogForm).then(res => {
                    this.$message({message: res.data, type: 'success'});
                    this.submitQueryForm();//新增之后，重新查询table
                    this.handleCloseDialog();
                  })
                }
                //取消新增或修改也要重置表单
              }).catch(_ => {this.handleCloseDialog();});
          } else {
            return false;
          }
        });
      },
      handleCloseDialog(){
        //resetFields就是一个坑，有两个作用
        //1.重置的值不是空的，而是第一次被赋予的值。
        //第一次dialogForm赋空值，后续才能重置为空值。
        //这就是我们在新增修改打开弹出框操作的时候，调用resetDialogFrom清空数据的原因。
        //2.清空校验结果
        this.$refs['dialogForm'].resetFields();
        this.dialogFormVisible = false;
      },
      beforeDialogClose(done){
        this.$confirm('确认关闭？')
          .then(_ => {
            this.$refs['dialogForm'].resetFields();
            done();
          }).catch(_ => {});
      },
      handleDelete(index, row) {
        this.$confirm("确定删除["+row.roleName+"]?")
          .then(_ => {
            deleteRole(row.id)
              .then(res => {
                this.submitQueryForm();//删除之后，重新查询table
                this.$message({message: res.data, type: 'success'});
              }).catch(err => {
              this.$message({message: err.message, type: 'error'});
            })
          });
      },
      otherAssignPerm(index, row){
        this.dialogFieldTitle = "其它操作权限设置"
        this.dialogFieldFormVisible = true;
        let _this = this;
        this.dialogFieldForm.roleCode = row.roleCode;
        queryAccessFieldInfos().then(res =>{
          if (res.success){
            _this.allFields = res.data;
            queryRoleAccessField(null, row.roleCode).then(res => {
              if (res.success){
                _this.b2cAccessFieldInfos = res.data.map(item => item.id);
                this.dialogFieldForm.b2cAccessFieldInfos.splice(0, this.dialogFieldForm.b2cAccessFieldInfos.length);
                _this.$forceUpdate();
              }
            }).catch(err => {
              this.$message({message: err.message, type: 'error'});
            })
          }
        }).catch(err => {
          this.$message({message: err.message, type: 'error'});
        })
      },
      assignPerm(index, row){
        this.handlingRoleId = row.id
        this.handlingRoleCode = row.roleCode
        let _this = this
        axios.all([getMenuCheckedTree(row.id), getApiCheckedTree(row.id)])
        .then(axios.spread(function (res1, res2) {
          // 两个请求都执行完成后，进入该函数
          _this.menuData = res1.data.tree
          _this.menuDefaultExpandedKeys = res1.data.expandedKeys
          _this.menuDefaultCheckedKeys = res1.data.checkedKeys
          _this.apiData = res2.data.tree
          _this.apiDefaultExpandedKeys = res2.data.expandedKeys
          _this.apiDefaultCheckedKeys = res2.data.checkedKeys
          _this.permDialogVisible = true;
          _this.permDialogTitle = row.roleName + "角色:权限分配"
        }));
      },
      handleMenuCheckedKeys(checkedKeys){
        saveMenuCheckedKeys(this.handlingRoleId,checkedKeys)
          .then(res => {
            this.$message({message: res.data, type: 'success'});
          })
      },
      handleApiCheckedKeys(checkedKeys){
        saveApiCheckedKeys(this.handlingRoleCode,this.handlingRoleId,checkedKeys)
          .then(res => {
            this.$message({message: res.data, type: 'success'});
          })
      },
      setData(roles) {
        if (roles.success) {
          this.tableData = roles.data
        }
      }
    },
    beforeRouteEnter(to, from, next) {
      getRoles("").then(res => {
        next(vm => vm.setData(res))
      })
    }
  }
</script>

<style scoped>
  .el-form {
    margin-top: 20px;
  }
</style>
